export const CORRECT_POSITION_POPOVER = {
  LEFT: 24,
  RIGHT: 76,
};
